import "./ruler.css";
export default class DeskpadRuler {
  constructor(container) {
    this.container = container;

    this.zoom = 1;
    this.widthK = 4;
    this.height = window.innerWidth > 480 ? 20 : 15;
    this.lineWidth = 1;
    this.font = window.innerWidth > 480 ? "bold 14px Arial" : "bold 12px Arial";
    this.constructRuler();
  }

  constructRuler = () => {
    const topRuler = document.createElement("canvas");
    topRuler.classList.add("dpe_top_ruler");
    this.container.appendChild(topRuler);
    this.initRuler(topRuler);
    this.topRuler = topRuler;

    const leftRuler = document.createElement("canvas");
    leftRuler.classList.add("dpe_left_ruler");
    this.container.appendChild(leftRuler);
    this.initRuler(leftRuler);
    this.leftRuler = leftRuler;
    this.rotateRuler(leftRuler, 90);
  };

  rotateRuler = function(ruler, angle) {
    const rotation = "rotate(" + angle + "deg)";
    const origin = "0 100%";
    ruler.style.webkitTransform = rotation;
    ruler.style.MozTransform = rotation;
    ruler.style.OTransform = rotation;
    ruler.style.msTransform = rotation;
    ruler.style.transform = rotation;
    ruler.style.webkitTransformOrigin = origin;
    ruler.style.MozTransformOrigin = origin;
    ruler.style.OTransformOrigin = origin;
    ruler.style.msTransformOrigin = origin;
    ruler.style.transformOrigin = origin;
  };

  setPos = (x, y) => {
    this.topRuler.style.left = -(this.topRuler.width / 2 + x) + "px";
    this.leftRuler.style.top =
      -(this.leftRuler.width / 2 + y + this.leftRuler.height) + "px";
  };

  setZoom = zoom => {
    this.zoom = zoom;
    this.initRuler(this.topRuler);
    this.initRuler(this.leftRuler);
  };

  initRuler = el => {
    const canvas = el;
    const context = canvas.getContext("2d");

    canvas.width = this.container.offsetWidth * this.widthK;
    canvas.height = this.height;
    var pointLength = 0,
      label = "",
      delta = 0,
      draw = false,
      lineLengthMax = 0,
      lastDrawedValue = 0,
      lineLengthMed = this.height / 3,
      lineLengthMin = this.height / 2;
    var maxCMValue = Math.round(Math.abs(canvas.width/2) * this.zoom * 0.1);

    for (var pos = 0; pos <= canvas.width; pos += 1) {
      delta = canvas.width / 2 - pos;
      draw = false;
      label = "";
      let color = "#444f";
      let cm = Math.round(Math.abs(delta) * this.zoom * 0.1);

      if (cm === lastDrawedValue) continue;

      if (cm % 100 === 0 || cm % 50 === 0) {
        pointLength = lineLengthMax;
        draw = true;
        if (cm >= 100) {
          label = (cm / 100).toFixed(1) + "m";
        } else {
          label = cm;
        }
      } else if (cm % 10 === 0 && maxCMValue < 7e2) {
        pointLength = lineLengthMax;
        draw = true;
        label = cm;
      } else if (cm % 5 === 0 && maxCMValue < 6e2) {
        pointLength = lineLengthMed;
        draw = true;
        color = "#444a";
      } else if (maxCMValue < 4e2){
        pointLength = lineLengthMin;
        draw = true;
        color = "#4448";
      }
      // for small sizes - show all numbers
      if (maxCMValue < 50){
        label = cm;
      }

      if (draw) {
        lastDrawedValue = cm;
        context.beginPath();
        context.strokeStyle = color;
        context.moveTo(pos + 0.5, this.height + 0.5);
        context.lineTo(pos + 0.5, pointLength + 0.5);
        context.font = this.font;
        context.fillStyle = "#444";
        context.fillText(label, pos + 1.5, this.height / 2 + 1);
        context.stroke();
      }
    }
  };
}
